<template>
  <div class="view-toggle" :class="{ disabled: disabled }">
    <div class="segmented">
      <div class="track">
        <v-chip color="white" class="chip" :class="chipClass" />
        <button
          v-for="opt in options"
          :key="opt.value"
          @click="selectOption(opt.value)"
          v-ripple
          class="segment"
          :class="{ 'is-active': value === opt.value }"
          :disabled="disabled">
          <span class="label" :class="{ active: value === opt.value }">
            {{ opt.text }}
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DiscountTypeToggle',
  props: {
    value: { type: String, required: true },
    options: {
      type: Array,
      required: true,
      validator: (arr) =>
        arr.length === 2 &&
        arr.every((o) => o != null && 'value' in o && 'text' in o),
    },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    isFirstOptionSelected() {
      return this.options[0]?.value === this.value
    },
    chipClass() {
      return this.isFirstOptionSelected ? 'left' : 'right'
    },
  },
  methods: {
    selectOption(value) {
      if (!this.disabled && value !== this.value) {
        this.$emit('input', value)
      }
    },
  },
}
</script>

<style scoped>
.view-toggle {
  display: block;
  width: 100%;
}

.view-toggle.disabled {
  opacity: 0.5;
  pointer-events: none;
  color: gray;
}

.segmented {
  display: block;
  width: 100%;
}

.track {
  --track-width: 100%;
  --track-height: 40px;
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: stretch;
  width: var(--track-width);
  max-width: 280px;
  height: var(--track-height);
  background: var(--v-primary-base);
  border-radius: 9999px;
  padding: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12) inset;
  overflow: hidden;
}

.chip.v-chip {
  --track-control-padding: 4px;
  --chip-width: calc(50% - calc(var(--track-control-padding) * 2));
  --chip-height: calc(var(--track-height) - 2 * var(--track-control-padding));
  --chip-border-radius: calc(var(--chip-height) / 2);
  position: absolute;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
  transition: left 80ms ease, width 80ms ease;
  border-radius: var(--chip-border-radius);
  width: var(--chip-width);
  height: var(--chip-height);
  top: var(--track-control-padding);
  left: var(--track-control-padding);
}

.chip.right {
  left: calc(50% + var(--track-control-padding));
}

.segment {
  position: relative;
  z-index: 1;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  outline: none;
}

.label {
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
  font-size: 0.8125rem;
  transition: color 80ms ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.label.active {
  color: var(--v-primary-base);
}
</style>
